package chat.amp.tim.web

import chat.amp.tim.ampConfiguration
import de.connect2x.messenger.compose.view.startMessenger
import web.location.location

suspend fun main() = startMessenger(
    configuration = ampConfiguration(
        customConfig = {
            urlProtocol = location.protocol.dropLast(1)
            urlHost = location.host
            messengerConfiguration {
                ssoRedirectPath = "sso.html"
            }
        },
        customTIMConfig = {
            productAbbreviation = "AMP_Pro_Web"
        }
    ),
)
